export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_fragment_7.4b84ea80.jpg";